import React, { Dispatch, FC, useEffect, useState } from 'react';
import { Dialog, DialogTitle, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ReactComponent as Close } from '../../../assets/images/close.svg';
import classes from './changeUpdateDialog.module.scss';

type ChangeUpdateDialogProps = {
  open: boolean;
  setOpen: Dispatch<boolean>;
  onChangeUpdate: Dispatch<string>;
  value: string;
};

export const ChangeUpdateDialog: FC<ChangeUpdateDialogProps> = ({
  open,
  setOpen,
  onChangeUpdate,
  value,
}) => {
  const [textTextarea, setTextTextarea] = useState<string>('');
  const [change, setChange] = useState<boolean>(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleSubmit = () => {
    setChange(true);
    if (textTextarea !== value && textTextarea) {
      onChangeUpdate(textTextarea);
    }
  };
  useEffect(() => {
    setTextTextarea(value);
  }, []);
  const useStyles = makeStyles({
    save: {
      background: '#FF7221',
      borderRadius: 0,
      color: 'white',
      maxWidth: 220,
      width: '100%',
      fontSize: 16,
      fontWeight: 550,
      textTransform: 'none',
      '&:hover, &:focus': {
        background: '#e76114',
      },
      fontFamily: 'HelveticaNeueCyr',
      // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      height: 50,
      padding: '0 18px',
    },
    cancel: {
      background: 'none',
      borderRadius: 0,
      color: '#FF7221',
      maxWidth: 220,
      width: '100%',
      fontSize: 16,
      textTransform: 'none',
      fontWeight: 550,
      '&:hover, &:focus': {
        background: '#FF7221',
        color: 'white',
      },
      fontFamily: 'HelveticaNeueCyr',
      // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      height: 50,
      padding: '0 18px',
      border: '1px solid #FF7221',
    },
    radioGroup: {
      display: 'flex',
    },
  });
  const style = useStyles();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      fullWidth
      maxWidth="sm"
      className={classes.wrapperDialog}
    >
      <div className={classes.form}>
        <DialogTitle>
          <div className={classes.form__dialogTitle}>
            <span className={classes.title}>Редактирование спасибо</span>
            <div className={classes.close} onClick={() => setOpen(false)}>
              <Close />
            </div>
          </div>
        </DialogTitle>
        <div className={classes.wrapper}>
          <p className={classes.desc}>Комментарий к спасибо</p>
          <textarea
            onChange={(e) => setTextTextarea(e.target.value)}
            className={`${classes.textarea} ${
              (textTextarea === value || !textTextarea) && change
                ? classes.error
                : ''
            }`}
          >
            {textTextarea}
          </textarea>
        </div>

        <div className={classes.form__row__buttons}>
          <Button
            className={style.cancel}
            onClick={handleClose}
            color="primary"
          >
            Отмена
          </Button>
          <Button onClick={handleSubmit} className={style.save}>
            Сохранить
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
